import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { SubscriptionUpsell } from 'mr-components';

const SubscriptionUpsellPage = ({
  mrCart,
  offer,
  cartIndex,
  handleSubscription,
  isMobile,
  isDrawer,
}) => {
  const [initialState, setInitialState] = useState({
    previousGroupIndex: 0,
    previousPlanIndex: 0,
    selectedPlan: null,
    showDropdown: false,
  });

  const {
    theme: { isRefreshPageAfterProductAddition },
  } = offer;

  const {
    sellingPlanGroups,
    variantID,
  } = offer.subscription.cartItemsSubscriptionData.find(
    item => item.cartIndex === cartIndex,
  );

  const productKey = mrCart[cartIndex].key;

  useEffect(() => {
    const keyTracker = {};

    mrCart.forEach(
      item => (keyTracker[item.key] = !!item.selling_plan_allocation),
    );

    const product = mrCart.find(
      (_, itemIndex) => keyTracker[productKey] && itemIndex === cartIndex,
    );

    if (
      product &&
      product.selling_plan_allocation &&
      product.selling_plan_allocation.selling_plan.id > 0
    ) {
      for (let i = 0; i < sellingPlanGroups.length; i += 1) {
        for (let j = 0; j < sellingPlanGroups[i].sellingPlans.length; j += 1) {
          if (
            sellingPlanGroups[i].sellingPlans[j].id ===
            product.selling_plan_allocation.selling_plan.id
          ) {
            setInitialState({
              previousGroupIndex: i,
              previousPlanIndex: j,
              selectedPlan: sellingPlanGroups[i].sellingPlans[j],
              showDropdown: true,
            });
          }
        }
      }
    }
  }, []);

  const { subscription } = offer;
  const defalutSellingPlanGroupIndex =
    subscription.cartItemsSubscriptionData[cartIndex]
      .defalutSellingPlanGroupIndex || 0;
  const defalutSellingPlanGroupPlanIndex =
    subscription.cartItemsSubscriptionData[cartIndex]
      .defalutSellingPlanGroupPlanIndex || 0;

  const handleSubscriptionButtonApiRequest = async (e, cb) => {
    const productKey = mrCart[cartIndex].key;

    const response = await handleSubscription({
      sellingPlanId:
        sellingPlanGroups[defalutSellingPlanGroupIndex].sellingPlans[
          defalutSellingPlanGroupPlanIndex
        ].id,
      key: productKey,
      spVariantId: variantID,
      callAddEventApi: true,
      isRefresh: isRefreshPageAfterProductAddition,
      cartIndex,
    });

    if (response) cb();
  };

  const handleGroupItemApiRequest = async (plan, cb) => {
    const productKey = mrCart[cartIndex].key;

    if (plan.planText === 'one-time-only') {
      const response = await handleSubscription({
        sellingPlanId: '',
        key: productKey,
        spVariantId: variantID,
        callAddEventApi: false,
        isRefresh: isRefreshPageAfterProductAddition,
        cartIndex,
      });
      if (response) cb();
    } else {
      const response = await handleSubscription({
        sellingPlanId: plan.id,
        key: productKey,
        spVariantId: variantID,
        callAddEventApi: true,
        isRefresh: isRefreshPageAfterProductAddition,
        cartIndex,
      });
      if (response) cb();
    }
  };

  return (
    <SubscriptionUpsell
      mrCart={mrCart}
      offer={offer}
      cartIndex={cartIndex}
      handleSubscription={handleSubscription}
      isMobile={isMobile}
      handleSubscriptionButtonApiRequest={handleSubscriptionButtonApiRequest}
      handleGroupItemApiRequest={handleGroupItemApiRequest}
      initialState={initialState}
      isDrawer={isDrawer}
    />
  );
};

SubscriptionUpsellPage.propTypes = {
  mrCart: PropTypes.object,
  offer: PropTypes.object,
  cartIndex: PropTypes.number,
  handleSubscription: PropTypes.func,
  isMobile: PropTypes.bool,
  isDrawer: PropTypes.bool,
};

export default SubscriptionUpsellPage;
